<template>
  <v-select
    v-model="item"
    :dir="$dir"
    :clearable="clearable"
    label="Title"
    :multiple="multiple"
    :options="paginated"
    :filterable="false"
    :disabled="disabled"
    :loading="loading"
    :selectable="x => unselectable.includes(x.Id) === false || x === val"
    @open="onOpen"
    @close="onClose"
    @search="query => search = query"
    @option:selected="$emit('selectedItem',$event)"
    @option:deselected="$emit('deselected',$event)"
  >
    <span
      slot="no-options"
      @click="$refs.select.open = false"
    >
      {{ $t('common.noOptions') }}
    </span>
    <template #spinner>
      <div class="demo-inline-spacing">
        <b-spinner
          v-if="loading"
          class="m-0"
          small
          variant="secondary"
        />
      </div>
    </template>
    <template #list-footer>
      <li
        v-show="hasNextPage"
        ref="load"
        class="loader"
      >
        در حال دریافت اطلاعات ...
      </li>
    </template>
  </v-select>
</template>

<script>

import vSelect from 'vue-select'
import { mapState } from 'vuex'

export default {
  name:'ZFood',
  components: {
    vSelect,
  },
  props: {
    value: {
      type: [String, Number, Array],
      default: null,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    unselectable: {
      type: Array,
      default: () => [],
    },
    clearable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      val: {},
      observer: null,
      limit: 20,
      search: '',
      loading: false,
    }
  },
  mounted() {
    this.observer = new IntersectionObserver(this.infiniteScroll)
  },
  computed: {
    ...mapState('zirehState', { items: state => state.foodSelect }),
    ...mapState('zirehState', { flag: state => state.foodSelectFlag }),
    filtered() {
      return this.items.filter(x => x.Title.includes(this.search))
    },
    paginated() {
      return this.filtered.slice(0, this.limit)
    },
    hasNextPage() {
      return this.paginated.length < this.filtered.length
    },
    item: {
      get() {
        if (this.value && (this.value.length || this.multiple === false)) {
          this.get()
        }
        if (this.multiple && this.value.length) {
          return this.items.filter(x => this.value.includes(x.Id))
        }
        return this.items.filter(x => x.Id === this.value)[0]
      },
      set(newValue) {
        if (this.multiple) {
          this.$emit('input', newValue.map(x => x.Id))
          this.val = newValue
        } else {
          this.$emit('input', newValue?.Id)
          // this.val = newValue
        }
      },
    },
  },
  methods: {
    async get() {
      if (this.flag === false && this.items.length === 0) {
        this.$store.commit('zirehState/setFoodSelectFlag', true)
        this.loading = true
        this.$http.post(
          this.$api.food.getall, {},
        )
          .then(res => {
            this.loading = false
            this.$store.commit('zirehState/setFoodSelect', res.data)
            this.onOpen()
          })
      }
    },
    async onOpen() {
      await this.get()
      if (this.hasNextPage) {
        await this.$nextTick()

        if (this.$refs.load) {
          this.observer.observe(this.$refs.load)
        }
      }
    },
    onClose() {
      this.observer.disconnect()
    },
    async infiniteScroll([{ isIntersecting, target }]) {
      if (isIntersecting) {
        const ul = target.offsetParent
        const { scrollTop } = target.offsetParent
        this.limit += 20
        await this.$nextTick()
        ul.scrollTop = scrollTop
      }
    },
  },
}
</script>
